import React from "react";
import { useForm } from "react-hook-form";
import axios from "axios";

import { withRouter, useLocation } from "react-router-dom";

import { createBrowserHistory } from "history";

import * as Constants from "./Constants";
import { ToastContainer, toast } from "react-toastify";

const baseUrl = Constants.URL();

const history = createBrowserHistory();

function UnSubscribe({ match }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  var email = match.params.email.split("=")[1];

  const [post, setPost] = React.useState(null);
  const [subscriptionData, setSubscription] = React.useState(null);
  const [invalidEmail, setInvalidEmail] = React.useState(null);
  const [other, setOther] = React.useState(false);
  const [currentRadioValue, setCurrentRadioValue] = React.useState();
  const toastId = React.useRef(null);

  function onChange(e) {
    setSubscription(e.target.value);
    emailValidation();
  }

  const setQuestion = function (e) {
    var selected = e.target.value;
    setCurrentRadioValue(selected);
    setOther(false);

    if (selected === "Other (fill in reason below)") {
      setOther(true);
    }
  };

  function emailValidation() {
    const regex =
      '/^(([^<>()[].,;:s@"]+(.[^<>()[].,;:s@"]+)*)|(".+"))@(([^<>()[].,;:s@"]+.)+[^<>()[].,;:s@"]{2,})$/i';
    if (!email || regex.test(email) === false) {
      setInvalidEmail("Email is not valid");
      return false;
    }
    return true;
  }

  const onSubmit = function (data) {
    var unsubscribeViewModel = {
      email: data.email,
      reason: other ? data.other : currentRadioValue,
    };

    if (data.email !== undefined) {
      axios
        .post(`${baseUrl}Unsubscribe/Unsubscribing`, unsubscribeViewModel)
        .then((response) => {
          if (!toast.isActive(toastId.current)) {
            toastId.current = toast.success("Submitted Successfully", {
              toastId: "success",
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              hideProgressBar: false,
              draggable: false,
              progress: undefined,
              theme: "light",
              draggablePercent: 0,
            });

            const location = {
              pathname: `/Newsletters`,
              state: { fromDashboard: true },
            };

            history.push(location);

            setTimeout(() => window.location.reload(), 3000);
          }
        });
    }
  };

  return (
    <div className="Card u-marginAuto u-marginBottom20">
      <div className="Card-content u-marginTop10">
        <form onSubmit={handleSubmit(onSubmit)}>
          <input
            className="customInput"
            type="hidden"
            name="csrfmiddlewaretoken"
            value="0aiY5RDRupxjz3ITP49uNZ3YYfET3oeBn3RewbVyTP1JNRJIwc6YRdCACn9UbrQr"
          />
          <input
            className="customInput"
            type="hidden"
            name="csrfmiddlewaretoken"
            value="0aiY5RDRupxjz3ITP49uNZ3YYfET3oeBn3RewbVyTP1JNRJIwc6YRdCACn9UbrQr"
          />
          <h2 className="Card-title u-marginBottom20">Unsubscribe</h2>
          <p>
            We`re sorry to see you go! Enter your email address to unsubscribe
            from the list.
          </p>
          <p>
            <label htmlFor="email">Email address:</label>
            <input
              className="customInput"
              type="email"
              name="email"
              autoFocus="autoFocus"
              {...register("email", { required: true })}
              id="id_email"
              value={email}
              onChange={onChange}
            />
          </p>
          {errors.email && errors.email.type === "required" && (
            <span className="required">Email address is required</span>
          )}
          <p>You will no longer receive emails from Vulekamali</p>
          <h4>
            <b>
              If you have a moment, please let us know why you unsubscribed:
            </b>
          </h4>
          <input
            className="customRadioButton"
            name="questions"
            onChange={setQuestion}
            type="radio"
            value="I no longer want to receive these emails"
          />
          I no longer want to receive these emails<br></br>
          <input
            className="customRadioButton"
            name="questions"
            onChange={setQuestion}
            type="radio"
            value="I never signed up for this mailing list"
          />
          I never signed up for this mailing list<br></br>
          <input
            className="customRadioButton"
            name="questions"
            onChange={setQuestion}
            type="radio"
            value="The emails are inapproriate"
          />
          The emails are inapproriate<br></br>
          <input
            className="customRadioButton"
            name="questions"
            onChange={setQuestion}
            type="radio"
            value="The emails are spam and should be reported"
          />
          The emails are spam and should be reported<br></br>
          <input
            className="customRadioButton"
            name="questions"
            onChange={setQuestion}
            type="radio"
            value="Other (fill in reason below)"
          />
          Other (fill in reason below)<br></br>
          {other && (
            <>
              <p>
                <label htmlFor="other">Reason:</label>
                <input
                  className="customInput"
                  type="text"
                  name="other"
                  autoFocus="autoFocus"
                  {...register("other", { required: true })}
                  id="id_other"
                />
              </p>
              {errors.other && other && errors.other.type === "required" && (
                <span className="required">Give a reason</span>
              )}
            </>
          )}
          <button className="Button" value="Unsubscribe" onClick={onSubmit}>
            Unsubscribe
          </button>
        </form>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <ToastContainer />
    </div>
  );
}

export default withRouter(UnSubscribe);
